import * as h2Api from '../../h2Api'
import { appendSearchResults, initSearchResults } from '../search'

export const LONG_IP_RESULTS = 'LONG_IP_RESULTS'
export const ADD_LONG_IP_RESULTS = 'ADD_LONG_IP_RESULTS'

export const loadLongIpResults = filters => dispatch => {
  return dispatch(
    h2Api.post(`/assessment/ip/long/results`, { filters })({ type: LONG_IP_RESULTS })
  ).then(v => {
    dispatch(initSearchResults(v.results))

    return v
  })
}

export const loadSubsequentLongIpResults = filters => (startIdx, endIdx) => dispatch => {
  const updatedJson = {
    filters,
    start: startIdx,
    end: endIdx
  }

  return dispatch(
    h2Api.post(`/assessment/ip/long/results`, updatedJson)({ type: ADD_LONG_IP_RESULTS })
  ).then(v => {
    console.log('APPENDING')
    dispatch(appendSearchResults(v.results))
  })
}
